import { HttpService } from '../http.service'

const http = new HttpService()

export interface SetWorkspaceOverridePayload {
  overrideWorkspaceId: string
}

export interface WorkspaceItem {
  id: string
  name: string
  status: string
}

export async function setWorkspaceOverride(
  payload: SetWorkspaceOverridePayload
): Promise<boolean> {
  const { data }: any = await http.put('auth/users/me/workspace', payload)
  return Boolean(data?.success === true)
}

export async function getWorkspaces(search?: string): Promise<WorkspaceItem[]> {
  const { data } = await http.get('auth/users/workspaces', {
    params: {
      search: search === '' ? undefined : search
    }
  })
  return (data ?? []) as WorkspaceItem[]
}
